import React, { useState, useEffect } from "react";
import UploadFile from "./UploadFiles";
import "../../style/Fournisseur.css";
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";

import { useToasts } from "react-toast-notifications";

const API_URL = process.env.REACT_APP_API_URL;

function AdminMutuelle() {
  const [mutuelle, setMutuelle] = useState([]);
  const { mutuelleId } = useParams();
  const history = useHistory();
  const { addToast } = useToasts();

  const TOKEN_KEY = "jwt";
  const token = localStorage.getItem(TOKEN_KEY);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMutuelle((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function submitForm(e) {
    e.preventDefault();
    axios
      .put(`${API_URL}/api/mutuelles/${mutuelleId}`, mutuelle, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then((res) => res.data)
      .then(() => {
        addToast("fournisseur modifié !", {
          appearance: "success",
          autoDismiss: true,
        });
        history.push("/backoffice/home");
      })
      .catch((e) => {
        console.error(e);
        addToast(`Erreur : ${e.message}`, {
          appearance: "error",
          autoDismiss: true,
        });
      });
  }

  function removeMutuelle() {
    if (window.confirm("Êtes-vous sûr de vouloir supprimer cette mutuelle ?")) {
      axios
        .delete(`${API_URL}/api/mutuelles/${mutuelleId}`, {
          headers: {
            authorization: `Bearer ${token}`,
          },
        })
        .then(() => {
          addToast("Mutuelle supprimée !", {
            appearance: "success",
            autoDismiss: true,
          });
        })
        .catch((e) => {
          console.error(e);
          addToast(`${e.message}`, {
            appearance: "error",
            autoDismiss: true,
          });
        });
    }
  }

  useEffect(() => {
    function getMutuelle() {
      axios
        .get(`${API_URL}/api/mutuelles/${mutuelleId}`)
        .then((res) => res.data)
        .then((data) => {
          setMutuelle(data);
        });
    }

    getMutuelle();
  }, []);

  return (
    <div className="fournisseurMain">
      <a
        href={mutuelle.site_internet}
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>
          {mutuelle.id ? (
            <img
              src={`${API_URL}/images/mutuelles/${mutuelle.id}.png`}
              alt="Logo"
              className="fournisseurLogo"
            />
          ) : (
            "Loading"
          )}
          <h1>
            {mutuelle.nom
              ? `${mutuelle.nom.charAt(0).toUpperCase()}${mutuelle.nom.slice(
                  1
                )}`
              : null}
          </h1>
        </span>
      </a>
      <h2>Contact</h2>
      <form onSubmit={submitForm}>
        Nom :{" "}
        <input
          type="text"
          value={mutuelle.nom}
          name="nom"
          onChange={handleChange}
        />
        <br />
        Adresse 1 :{" "}
        <input
          type="text"
          value={mutuelle.adresse_rue_1}
          name="adresse_rue_1"
          onChange={handleChange}
        />
        <br />
        Adresse 2 :{" "}
        <input
          type="text"
          value={mutuelle.adresse_rue_2}
          name="adresse_rue_2"
          onChange={handleChange}
        />
        <br />
        Code Postal :{" "}
        <input
          type="text"
          value={mutuelle.adresse_code_postal}
          name="adresse_code_postal"
          onChange={handleChange}
        />
        <br />
        Ville :{" "}
        <input
          type="text"
          value={mutuelle.adresse_ville}
          name="adresse_ville"
          onChange={handleChange}
        />
        <br />
        Pays :{" "}
        <input
          type="text"
          value={mutuelle.adresse_pays}
          name="adresse_pays"
          onChange={handleChange}
        />
        <br />
        Site internet :{" "}
        <input
          type="url"
          value={mutuelle.site_internet}
          name="site_internet"
          onChange={handleChange}
        />
        <br />
        Télephone :{" "}
        <input
          type="text"
          value={mutuelle.telephone}
          name="telephone"
          onChange={handleChange}
        />
        <br />
        Fax :{" "}
        <input
          type="text"
          value={mutuelle.fax}
          name="fax"
          onChange={handleChange}
        />
        <br />
        Adresse mail :{" "}
        <input
          type="email"
          value={mutuelle.email}
          name="email"
          onChange={handleChange}
        />
        <button type="submit">Enregistrer</button>
      </form>
      <UploadFile id={mutuelleId} category={"mutuelles"} />
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <button type="button" onClick={removeMutuelle}>
        Supprimer
      </button>
    </div>
  );
}

export default AdminMutuelle;
